export const getChipSx = (hasIcon: boolean) =>
  ({
    display: 'inline-flex',
    alignItems: 'center',
    minWidth: 0,
    maxWidth: '100%',
    gap: 0.75,
    height: 22,
    pl: hasIcon ? '5px' : '11px',
    pr: '11px',
    borderRadius: '11px',
    backgroundColor: 'background.antiflashWhite',
    color: 'text.secondary',
    fontSize: 12,
    lineHeight: '22px',
    whiteSpace: 'nowrap',
  }) as const;
